import { Route, Routes } from "react-router-dom";
import { AjanvarausPage, Errorpage, Etusivu, Otayhteytta, PalveluHieronta, PalveluRavintov, PalveluSairaanhoito, Palvelut, PalvelutKrania, PalveluTTO, PalveluVyohyke, Tietoja, Tietosuojaseloste } from "../src/pages/index";
import './App.css';
import ScrollToTop from './hooks/ScrollToTop';

function App() {
  // Function to protect admin routes
  return (
    <>
    <ScrollToTop/>
        <Routes>
          <Route path="/" element={<Etusivu title="SL Health - Etusivu"/> } />
          <Route path="/tietoja" element={<Tietoja />} />
          <Route path='/otayhteytta' element={<Otayhteytta/>}/>
          <Route path='/palvelut' element={<Palvelut/>}/>
          <Route path='/ravintovalmennus' element={<PalveluRavintov/>}/>
          <Route path='/hieronta' element={<PalveluHieronta/>}/>
          <Route path='/kraniosakraaliterapia' element={<PalvelutKrania/>}/>
          <Route path='/tunne-ja-tietoisuustaito-ohjaus' element={<PalveluTTO/>}/>
          <Route path='/vyohyketerapia' element={<PalveluVyohyke/>}/>
          <Route path='/sairaanhoitajan-vastaanotto' element={<PalveluSairaanhoito/>}/>
          <Route path='/tietosuojaseloste' element={<Tietosuojaseloste/>}/>
          <Route path='/ajanvaraus' element={<AjanvarausPage/>}/>
          <Route path='/*' element={<Errorpage/>}/>
        </Routes>
    </>
  );
}

export default App;
